import { render, staticRenderFns } from "./invoiceDetail.vue?vue&type=template&id=666cceca&scoped=true"
import script from "./invoiceDetail.vue?vue&type=script&lang=js"
export * from "./invoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./invoiceDetail.vue?vue&type=style&index=0&id=666cceca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666cceca",
  null
  
)

export default component.exports